@if (showStrip) {
    <div class="notification" [ngStyle]="style" [style.backgroundColor]="outletState === OutletState.PREORDER ? '#DCF8F7' : '#ffd9c4'">
        <div class="left">
            <img class="icon" [src]="icon" alt="icon" />
        </div>
        <div class="right">
            <div class="header">
                <div class="heading">{{ header }}</div>
            </div>
            <div class="description">{{ message }}</div>
        </div>
        @if (allowRefresh) {
            <!-- can use spinner -->
            <button class="refresh-cta center" (click)="onRefreshClick.emit()">
                Refresh
                <div class="mask">
                    <div class="refresh-img"></div>
                </div>
            </button>
        }
    </div>
}
